document.documentElement.classList.remove('no-js');

class AnnouncementRotator {
  constructor(root) {
    this.root = root;
    this.items = [...root.querySelectorAll('[data-announcement-item]')];
    this.index = 0;
    this.delay = Number(root.dataset.delay || 5000);

    if (this.items.length < 2) return;

    root
      .querySelector('[data-announcement-prev]')
      ?.addEventListener('click', () => this.show(this.index - 1));

    root
      .querySelector('[data-announcement-next]')
      ?.addEventListener('click', () => this.show(this.index + 1));

    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());

    this.start();
  }

  show(next) {
    this.items[this.index]?.classList.remove('is-active');
    this.index = (next + this.items.length) % this.items.length;
    this.items[this.index]?.classList.add('is-active');
  }

  start() {
    this.stop();
    this.timer = setInterval(
      () => this.show(this.index + 1),
      this.delay
    );
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }
}

document
  .querySelectorAll('[data-announcement]')
  .forEach((el) => new AnnouncementRotator(el));

document.querySelectorAll('.mobile-menu').forEach((menu) => {
  menu.addEventListener('toggle', () => {
    document.body.classList.toggle('menu-open', menu.open);
  });

  menu.querySelectorAll('[data-mobile-close]').forEach((button) => {
    button.addEventListener('click', () => {
      menu.open = false;
    });
  });
});

document.querySelectorAll('[data-quantity]').forEach((quantity) => {
  const input = quantity.querySelector('input');

  quantity
    .querySelector('[data-minus]')
    ?.addEventListener('click', () => {
      input.value = Math.max(
        Number(input.min || 1),
        Number(input.value || 1) - 1
      );

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

  quantity
    .querySelector('[data-plus]')
    ?.addEventListener('click', () => {
      input.value = Math.min(
        Number(input.max || 9999),
        Number(input.value || 1) + 1
      );

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });
});

const sortSelect = document.querySelector('[data-sort-by]');

if (sortSelect) {
  sortSelect.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  });
}

document
  .querySelectorAll('[data-variant-picker]')
  .forEach((picker) => {
    const variantJson = picker.querySelector(
      '[data-variant-json]'
    );

    const variantInput = picker.querySelector(
      '[data-variant-id]'
    );

    if (!variantJson || !variantInput) return;

    let variants = [];

    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (error) {
      console.error(
        'Varianten konnten nicht geladen werden:',
        error
      );

      return;
    }

    const formId = variantInput.getAttribute('form');
    const productForm = document.getElementById(formId);

    const addButton = productForm?.querySelector(
      '[name="add"]'
    );

    const productSection = picker.closest('.product');

    const priceElement = productSection?.querySelector(
      '.product__price'
    );

    const mediaGrid = productSection?.querySelector(
      '.product__media-grid'
    );

    const currency =
      picker.dataset.currency || 'EUR';

    const locale =
      document.documentElement.lang || 'de-DE';

    const addLabel =
      picker.dataset.addLabel || 'In den Warenkorb';

    const soldOutLabel =
      picker.dataset.soldOutLabel || 'Ausverkauft';

    const formatMoney = (amount) => {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(amount / 100);
    };

    const getSelectedOptions = () => {
      return [
        ...picker.querySelectorAll(
          '.variant-picker__group'
        )
      ].map((group) => {
        const checkedInput = group.querySelector(
          '.variant-picker__input:checked'
        );

        return checkedInput
          ? checkedInput.value
          : null;
      });
    };

    const updateSelectedLabels = () => {
      picker
        .querySelectorAll('.variant-picker__group')
        .forEach((group) => {
          const checkedInput = group.querySelector(
            '.variant-picker__input:checked'
          );

          const selectedLabel = group.querySelector(
            '[data-selected-option]'
          );

          if (checkedInput && selectedLabel) {
            selectedLabel.textContent =
              checkedInput.value;
          }
        });
    };

    const updateVariantImage = (variant) => {
      if (!mediaGrid) return;

      const mediaId = variant.featured_media_id;

      if (!mediaId) return;

      const selectedMedia = mediaGrid.querySelector(
        `[data-media-id="${mediaId}"]`
      );

      if (!selectedMedia) return;

      mediaGrid.prepend(selectedMedia);

      selectedMedia
        .querySelector('img')
        ?.setAttribute('loading', 'eager');
    };

    const updateVariant = () => {
      const selectedOptions =
        getSelectedOptions();

      const selectedVariant = variants.find(
        (variant) => {
          return variant.options.every(
            (option, index) => {
              return (
                option === selectedOptions[index]
              );
            }
          );
        }
      );

      updateSelectedLabels();

      if (!selectedVariant) {
        variantInput.value = '';

        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = soldOutLabel;
        }

        return;
      }

      variantInput.value = selectedVariant.id;

      if (addButton) {
        addButton.disabled =
          !selectedVariant.available;

        addButton.textContent =
          selectedVariant.available
            ? addLabel
            : soldOutLabel;
      }

      if (priceElement) {
        if (
          selectedVariant.compare_at_price &&
          selectedVariant.compare_at_price >
            selectedVariant.price
        ) {
          priceElement.innerHTML = `
            <s>
              ${formatMoney(
                selectedVariant.compare_at_price
              )}
            </s>
            <span class="price__sale">
              ${formatMoney(
                selectedVariant.price
              )}
            </span>
          `;
        } else {
          priceElement.innerHTML = `
            <span>
              ${formatMoney(
                selectedVariant.price
              )}
            </span>
          `;
        }
      }

      updateVariantImage(selectedVariant);

      const url = new URL(
        window.location.href
      );

      url.searchParams.set(
        'variant',
        selectedVariant.id
      );

      window.history.replaceState(
        {},
        '',
        url.toString()
      );
    };

    picker
      .querySelectorAll('.variant-picker__input')
      .forEach((input) => {
        input.addEventListener(
          'change',
          updateVariant
        );
      });

    updateVariant();
  });